import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonTripleYpsili';
const args = {};

export class OligonTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
